module.exports = __webpack_public_path__ + "waveform-rainbow.595d9ec.png";